export default "__VITE_ASSET__BNW7dvFz__"